import React from 'react';
import { Alert, Space, Tag, Typography } from 'antd';
import { SafetyCertificateOutlined } from '@ant-design/icons';
import CoveredProductsList from './CoveredProductsList';
import ClaimCitationLinks from './ClaimCitationLinks';
import { screeningStatusColor, reasonStatusColor } from '../utils/formatters';
import { screeningFieldLabels } from '../utils/constants';

const { Text } = Typography;

export default function ScreeningResult({ screening }) {
  if (!screening) return null;
  const missingFields = screening.missing_fields || [];
  const reasons = screening.reasons || [];

  return (
    <div className="glp1-screening-result">
      <Space size={8} wrap style={{ marginBottom: 8 }}>
        <SafetyCertificateOutlined />
        <Text strong>Bridge screening result</Text>
        <Tag color={screeningStatusColor(screening.status)}>{screening.label || screening.status}</Tag>
      </Space>

      {missingFields.length ? (
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 10 }}
          message="More information needed"
          description={missingFields.map((field) => screeningFieldLabels[field] || field).join(', ')}
        />
      ) : null}

      {reasons.length ? (
        <Space direction="vertical" size={8} style={{ width: '100%' }}>
          {reasons.map((reason, index) => (
            <div key={`${reason.code || reason.status}-${index}`} className="glp1-result-reason">
              <Tag color={reasonStatusColor(reason.status)} style={{ marginInlineEnd: 0, marginBottom: 4 }}>
                {reason.status === 'part_d_route' ? 'Part D route' : reason.status?.replace(/_/g, ' ')}
              </Tag>
              <Text>{reason.text}</Text>
              <ClaimCitationLinks citations={reason.citations || []} />
            </div>
          ))}
        </Space>
      ) : null}

      <CoveredProductsList products={screening.covered_products || []} />
    </div>
  );
}
